import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isLoggedIn } from '~/lib/pb';
import { TenantProvider } from '~/lib/tenantContext';
import { AppShell } from '~/components/AppShell/AppShell';
import { StaleSessionBanner } from '~/components/StaleSessionBanner/StaleSessionBanner';
import { CapabilityGuard } from '~/components/CapabilityGuard/CapabilityGuard';

export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ location }) => {
    if (!isLoggedIn()) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <TenantProvider>
      <StaleSessionBanner />
      <CapabilityGuard />
      <AppShell>
        <Outlet />
      </AppShell>
    </TenantProvider>
  );
}
